module.exports = __webpack_public_path__ + "media/notify-soft.875a121e.wav";